module.exports = __webpack_public_path__ + "img/電気回路_1_7_2.0bee309f.jpeg";